<div>
  <div class="back">
    <i class="db-icon db-icon-ds-arrow-small" *ngIf="userSubscription && !userSubscription.trialBoosterClient" (click)="onStepChange.emit(!!demoUser && mode !== 'editor' ? 'features' : 'plans')"></i>
    <h2 *ngIf="userSubscription && !userSubscription.trialBoosterClient">Try 10Web Pro Plans {{(mode === 'ssh') ? '' : 'for Free'}} </h2>
    <h2 *ngIf="userSubscription?.trialBoosterClient">Try 10Web Booster Pro for free</h2>
  </div>
  <hr *ngIf="mode === 'ssh'" class="db-ssh-hr">
  <ul class="db-checklist" *ngIf="mode !== 'ssh'">
    <li *ngFor="let point of points">
      <i class="db-icon db-icon-ds-checkmark-small" [ngClass]="{'green': userSubscription?.trialBoosterClient}"></i>
      <p class="db-checkout-points" [innerHTML]="point"></p>
    </li>
  </ul>
  <div class="one-month-free-plans__payment-wrap">
    <db-payment-info [invited]="isInvited"
                     [subscription]="chosenPlan"
                     [feature]="mode"
                     [user]="user"
                     [chosenPlan]="chosenPlan?.price"
                     [coupon]="coupon"
                     [newPrice]="newPrice"
                     [currentSubscription]="userSubscription"
                     [demoUser]="demoUser"
                     [isPaypalInvalidCode]="payPalInvalidCoupons.includes(couponCodeInput?.value)"
                     (onClose)="onClose.emit($event)"
                     (onLoading)="loading = $event"
                     (paymentIsPaypal)="handlePaymentIsPaypal($event)"></db-payment-info>
    <div>
      <hr>
      <div class="one-month-free-plans__payment-due-wrap">
        <ng-container *ngIf="userSubscription?.trialClient">
          <div *ngIf="!couponSectionToggled"
               class="db-one-month-free-plans__coupon-link" (click)="couponSectionToggled = true">
            <span>Have a promo code?</span>
          </div>
          <div class="mt20 coupon-input-wrap" *ngIf="couponSectionToggled" [ngClass]="{'pb10': coupon?.couponCode}">
            <div class="db-one-month-free-plans__coupon-wrap"
                 *ngIf="!coupon || !coupon?.couponCode || coupon?.couponCode === '1wf'">
              <div class="ds-input-wrap" [ngClass]="{'with-error': (payPalInvalidCoupons.includes(couponCodeInput?.value) &&
      !!isPaypal)}">
                <input type="text" class="ds-input" [ngClass]="{'error': couponCodeInput?.invalid ||
        (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}"
                       placeholder="Coupon code" [formControl]="couponCodeInput">
                <i *ngIf="couponCodeInput?.value" class="db-icon db-icon-ds-close delete-coupon" (click)="deleteCoupon(false)"></i>
                <span *ngIf="couponCodeInput?.invalid || (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)"
                      class="ds-input-error-msg"
                      [innerHTML]="((payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal) ?
              'text_invalidPaypalCouponCodeError' : 'text_checkout_coupon_server_error') |
              dbText"></span>
              </div>
              <button class="ds-btn ds-btn-xs" [ngClass]="{'ds-btn-disabled': couponLoading ||
      (payPalInvalidCoupons.includes(couponCodeInput?.value) && !!isPaypal)}" (click)="applyCoupon()">
                <span *ngIf="!couponLoading">Apply</span>
                <db-loading-circular-spinner *ngIf="couponLoading" color="dark"></db-loading-circular-spinner>
              </button>
            </div>
            <p *ngIf="coupon?.couponCode && coupon?.couponCode !== '1wf'" class="promo-code">
              <span>{{coupon?.couponCode}}</span>
              <i class="db-icon db-icon-close" (click)="deleteCoupon(!couponCodeInput?.invalid)"></i>
            </p>
          </div>
        </ng-container>
        <div>
          <div class="due-today" [ngClass]="{invisible: couponLoading}">
            <p>
              <b>Due today</b><span [innerHTML]="(mode === 'ssh' || !coupon?.freeDaysBeforePayment) ? '' : ' (' + coupon?.freeDaysBeforePayment + ' days free)'"></span>
            </p>
            <b>${{coupon?.freeDaysBeforePayment ? '0' : chosenPlan?.price - newPrice}}</b>
          </div>
          <p class="a db-one-month-free-checkout__then-pay" [ngClass]="{invisible: couponLoading || !coupon?.couponCode}">
            Your next payment of
            <span *ngIf="newPrice !== chosenPlan?.price" [ngClass]="{'discounted': !!newPrice}">
          ${{chosenPlan?.price}}</span>
            <span class="db-new-price"  *ngIf="newPrice">${{newPrice}}</span>
            will be charged on {{expirationDate | date: 'MMM d, y'}}, followed by {{chosenPlan?.type === 'month' ? 'monthly' : 'annual'}} payments of ${{chosenPlan?.price}}.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="text-center buttons-wrap" [ngClass]="{'mt30': !coupon?.couponCode}">
  <button class="{{userSubscription?.trialBoosterClient ? 'ds-btn-green' : isMobile ? 'ds-btn-outline-gray' :
  'ds-btn-black'}} ds-btn-xl rectangle" [ngClass]="{'ds-btn-disabled': loading}" (click)="changeSubscrId();
  paymentInfo.checkoutHandler(coupon)">
    <span *ngIf="!loading">{{(mode === 'ssh' ? 'Proceed' : userSubscription?.trialBoosterClient ?
            'Try 10Web booster pro for 7 days' : 'Try 10Web free for 7 days') | lowerCaseSpecificWords}}</span>
    <db-loading-circular-spinner [color]="userSubscription?.trialBoosterClient ? 'gray' : isMobile ? 'gray' :
  'white'" *ngIf="loading"></db-loading-circular-spinner>
  </button>
</div>
